import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LocalstorageService } from '../localstorage.service';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root' 
})
export class PlanogramOptimizerService {
 
  environment = EnvironmentService.environment;
  updatePlanogramItem = new Subject();

  planogramItemActionHandler = new Subject();

  constructor(private httpClient: HttpClient, private storage: LocalstorageService) { }

  addPlanogramData(file: any, name: string, user: Number) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('user', user.toString());
    return this.httpClient.post<any>(this.environment.PlanogramUrl + `/planogram/?user=${user}&name=${name}`, formData);
  }

  getPlanogramData(name: string, user: Number) {
    return this.httpClient.get<any>(this.environment.PlanogramUrl + `/planogram/?user=${user}&name=${name}`);
  }

  updatePlanogramData(id: Number, obj = {}) {
    return this.httpClient.put<any>(this.environment.PlanogramUrl + `/planogram/${id}`, obj);
  }

  bulkUpdatePlanogramData(obj: FormData) {
    return this.httpClient.post<any>(this.environment.PlanogramUrl + '/update-previous-planogram/', obj);
  }

  addNewMovies(file: any, name: string, user: Number) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('user', user.toString());
    return this.httpClient.post<any>(this.environment.PlanogramUrl + `/new-movies/`, formData);
  }

  addSingleMovie(newMovieObj: any) {
    return this.httpClient.post<any>(this.environment.PlanogramUrl + '/add-single-movie/', newMovieObj);
  }

  getNewMovies(name: string, user: Number) {
    return this.httpClient.get<any>(this.environment.PlanogramUrl + `/new-movies/?user=${user}&name=${name}`);
  }

  updateMovie(id: number, movieObj: {}) {
    return this.httpClient.put<any>(this.environment.PlanogramUrl + `/new-movies/${id}`, movieObj);
  }

  deleteMovie(id: any) {
    return this.httpClient.delete<any>(this.environment.PlanogramUrl + `/new-movies/${id}`);
  }

  runOptimizer(obj: FormData) {
    return this.httpClient.post<any>(this.environment.PlanogramUrl + `/run-optimization/`, obj);
  }

  getLatestNames() {
    return this.httpClient.get<any>(this.environment.PlanogramUrl + '/get-latest-optimizer-movies/');
  }

  savePlanogram(obj: FormData) {
    return this.httpClient.post<any>(this.environment.PlanogramUrl + '/save-planogram/', obj);
  }

  fetchLockedPlanogram() {
    return this.httpClient.get<any>(this.environment.PlanogramUrl + '/save-planogram/');
  }

  deleteSavedPlanogram(name: any) {
    return this.httpClient.delete<any>(this.environment.PlanogramUrl + `/save-planogram/${name}`);
  }

  updatePlanogramOnSwap(obj: FormData) {
    return this.httpClient.put<any>(this.environment.PlanogramUrl + '/save-planogram/', obj);
  }
}
